import {Box, Chip, Stack, Typography} from "@mui/material";
import {FullPayoutStyledTile, StyledTile} from "../../pages/serviceModules/ServiceModules.styles";
import {useTranslation} from "react-i18next";
import {FullPayoutModuleSummary} from "../../types/fullPayoutTypes";

interface Props {
    module: FullPayoutModuleSummary;
    onCardClick: (module: FullPayoutModuleSummary) => void;
}

const MAX_VISIBLE_GROUPS = 2;

export default function FullPayoutModuleCard(props: Props) {
    const { t } = useTranslation();
    const m = props.module;

    const visibleGroups = m.groupNames.slice(0, MAX_VISIBLE_GROUPS);
    const remainingCount = m.groupNames.length - visibleGroups.length;

    return (
        <FullPayoutStyledTile onClick={() => props.onCardClick(m)}>
            <Box sx={{
                backgroundColor: 'primary.main',
                p: 2,
                display: 'flex',
                alignItems: 'baseline',
                justifyContent: 'center',
                gap: 0.5,
            }}>
                <Typography variant="h4" sx={{ color: 'white', fontWeight: 'bold' }}>
                    {m.orderDayInMonth}.
                </Typography>
                <Typography variant="body2" sx={{ color: 'white' }}>
                    {t("fullPayoutPage.ofMonth")}
                </Typography>
            </Box>

            <Stack sx={{ gap: 0.5, p: 2 }}>
                {m.isCompanyWideAssigned ? (
                    <Chip
                        label={t("fullPayoutPage.companyWide")}
                        size="small"
                        variant="outlined"
                    />
                ) : (
                    <>
                        {visibleGroups.map((name) => (
                            <Chip
                                key={name}
                                label={name}
                                size="small"
                                variant="outlined"
                            />
                        ))}
                        {remainingCount > 0 && (
                            <Chip
                                label={`+${remainingCount}`}
                                size="small"
                                variant="outlined"
                                color="default"
                            />
                        )}
                        {m.assignedEmployeeCount > 0 && (
                            <Chip
                                label={t("fullPayoutPage.employeeCount", { count: m.assignedEmployeeCount })}
                                size="small"
                                variant="outlined"
                                sx={{ mt: 0.5 }}
                            />
                        )}
                    </>
                )}
            </Stack>
        </FullPayoutStyledTile>
    );
}